import { IconProps } from "./IconProps";
import { svgIconProps } from "./svgIconProps";

export function IconSpinner(props: IconProps) {
  return (
    <svg {...svgIconProps(props)}>
      <path d="M12.75 3v3a.75.75 0 1 1-1.5 0V3a.75.75 0 1 1 1.5 0ZM21 11.25h-3a.75.75 0 1 0 0 1.5h3a.75.75 0 1 0 0-1.5Zm-4.227 4.463a.75.75 0 0 0-1.06 1.06l2.12 2.121a.75.75 0 0 0 1.061-1.06l-2.121-2.121ZM12 17.25a.75.75 0 0 0-.75.75v3a.75.75 0 1 0 1.5 0v-3a.75.75 0 0 0-.75-.75Zm-4.773-1.537-2.121 2.12a.75.75 0 0 0 1.06 1.061l2.121-2.121a.75.75 0 0 0-1.06-1.06ZM6.75 12a.75.75 0 0 0-.75-.75H3a.75.75 0 1 0 0 1.5h3a.75.75 0 0 0 .75-.75Zm-.583-6.894a.75.75 0 1 0-1.061 1.06l2.121 2.121a.75.75 0 0 0 1.06-1.06l-2.12-2.121Z" />
    </svg>
  );
}
